import { createContext, useContext } from 'react';

export type ColorMode = 'light' | 'dark';

export interface ThemeModeContextType {
  mode: ColorMode;
  toggleColorMode: () => void;
  setColorMode: (mode: ColorMode) => void;
}

export const ThemeModeContext = createContext<ThemeModeContextType>({
  mode: 'light',
  toggleColorMode: () => undefined,
  setColorMode: () => undefined,
});

export const useColorMode = (): ThemeModeContextType => useContext(ThemeModeContext);
